import ModuleWrapper from 'shared-lib/containers/Module';

const TaskList  = () => import(/* webpackChunkName: "task-list" */ '@/views/tasks/TaskList');
const TaskDetails  = () => import(/* webpackChunkName: "task-details" */ '@/views/tasks/TaskDetails');
const TaskImportDetails  = () => import(/* webpackChunkName: "task-import-details" */ '@/views/tasks/TaskImportDetails');
const TaskImportResults  = () => import(/* webpackChunkName: "task-import-details" */ '@/views/tasks/TaskImportResults');
const meta = (data = {}) => ({
    permissionsModuleName: 'system_settings.tasks',
    title: 'Tasks',
    auth: true,
    ...data,
});

export default [{
    path: 'tasks',
    component: ModuleWrapper,
    meta: meta(),
    children: [
        {
            path: '',
            name: 'Task List',
            component: TaskList,
            meta: meta(),
        },
        {
            path: ':id(\\d+)',
            name: 'Task Details',
            props: true,
            component: TaskDetails,
            meta: meta(),
        },
        {
            path: 'import/:id(\\d+)',
            name: 'TaskImportDetails',
            component: TaskImportDetails,
            props: true,
            meta: meta(),
        },
        {
            path: 'import/:id(\\d+)/results',
            name: 'TaskImportResults',
            component: TaskImportResults,
            props: true,
            meta: meta(),
        },
    ],
}];
